export const SPOTLIGHT_PADDING = 4;
export const TOOLTIP_GAP = 4;
export const TRANSITION =
  'top 200ms ease, left 200ms ease, width 200ms ease, height 200ms ease';
